import { createStyles } from "@mantine/core";

export default createStyles ( () => {
	return {
		containerClass: {
			width: "100%"
		}
	};
} );